{
  "custom-groups-create-error": "Unable to create custom group",
  "custom-groups-delete-error": "Unable to delete group",
  "custom-groups-rename-error": "Unable to rename group",
  "custom-groups-assign-error": "Unable to assign client to group",
  "custom-groups-unassign-error": "Unable to unassign client"
}
